import { connect } from 'react-redux';
import SidebarComp from '../components/menu/SidebarComp';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { fetchNavWorkflows, endCurrentBaseWorkflow } from '../actions/workflows';
import { toJS } from './to-js';
import CollapsedMenuWithSIdebar from '../components/menu/CollapsedMenuWithSIdebar';
import { getCustomIcons } from '../actions/company';
import CollapsedMenuWithSIdebarGroupIcon from '../components/menu/CollapsedMenuWithSIdebarGroupIcon';

const mapStateToProps = (state) => {
    const locale = state.get('locale');
    const companySettings = state.getIn(['company', 'details', 'data', 'companySettings']);
    return { 
        translate: getTranslate(locale),
        currentLanguage: getActiveLanguage(locale) ? getActiveLanguage(locale).code : 'en',
        user: state.get('user'),
        items: state.getIn(['navigation', 'data']),
         customIcons: state.getIn(['company', 'icons']),
         company: state.getIn(['company']),
        companySettings
      };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        fetchWorkflows: (user) => {
            dispatch(fetchNavWorkflows(user));
        },
        endCurrentBaseWorkflow: () => {
            dispatch(endCurrentBaseWorkflow());
        },
        getCustomIcons: payload => {
                    dispatch(getCustomIcons(payload));
                  },
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(toJS(CollapsedMenuWithSIdebarGroupIcon));